export const getPostAverageRating = (state: any, postId: any) =>
  state.postRatings[postId]?.averageRating;

export const getPostTotalRatings = (state: any, postId: any) =>
  state.postRatings[postId]?.totalRatings;
